package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.core.enumeration.Country
import pt.at.oss.kotlin.core.enumeration.EU_COUNTRIES_EXCEPT_PT
import pt.at.oss.kotlin.core.enumeration.PeculiarCountry
import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.lightweightform.kotlin.type.validator.ValidationCodes
import pt.lightweightform.kotlin.type.validator.ValidationError

/**
 * Created by Pedro Alfaiate on 14/05/2020.
 */
class CountryOfBusinessValidator {

    val validateSequencial = fun(countryOfBusiness: String?, region: String?, allowMSNoRegion: Boolean, allowPT: Boolean): List<ValidationError> {
        val errors = mutableListOf<ValidationError>()

        allowPTValidate(countryOfBusiness, allowPT)
            ?.also { errors.add(it) }

        countryOfBusinessValidate(countryOfBusiness, region, allowMSNoRegion)
            ?.also { errors.add(it) }

        validateRegion(region, countryOfBusiness)
            ?.also { errors.add(it) }

        return errors
    }

    val countryOfBusinessValidate = fun(countryOfBusiness: String?, region: String?, allowMSNoRegion: Boolean): ValidationError? {

        val allowedCountries = Country.values()
        val countryRequiresRegion = !allowMSNoRegion && EU_COUNTRIES_EXCEPT_PT.any { it.codeA2 == countryOfBusiness }
        val countryIsUk = Country.UNITED_KINGDOM.codeA2 == countryOfBusiness

        return if (allowedCountries.none { it.codeA2 == countryOfBusiness })
            ValidationError(code = CustomErrorCodes.COUNTRY_OF_BUSINESS_INVALID.code)

        else if (countryRequiresRegion && region.isNullOrBlank())
            ValidationError(code = CustomErrorCodes.COUNTRY_OF_BUSINESS_EU_NO_REGION.code)

        else if (countryIsUk && region.isNullOrBlank())
            ValidationError(code = CustomErrorCodes.COUNTRY_OF_BUSINESS_GB_NO_REGION.code)

        else
            null
    }

    val validateRegion = fun(regionA2: String?, countryA2: String?): ValidationError? {
        val region = regionA2?.let { PeculiarCountry.findByA2(regionA2) }

        return if (regionA2 == null)
            null

        else if (region == null)
            ValidationError(code = ValidationCodes.UNALLOWED_VALUE_CODE)

        else if (countryA2 != null && region.parentA2 != countryA2)
            ValidationError(code = CustomErrorCodes.REGION_WRONG_COUNTRY_OF_BUSINESS.code)

        else if (!region.isNonUnion)
            ValidationError(code = CustomErrorCodes.REGION_NOT_OUTSIDE_UNION.code)

        else
            null
    }

    val allowPTValidate = fun(countryOfBusiness: String?, allowPT: Boolean): ValidationError? {
        if (Country.PORTUGAL.codeA2 == countryOfBusiness) {
            return if (!allowPT) ValidationError(code = ValidationCodes.UNALLOWED_VALUE_CODE)
            else null
        }
        return null
    }
}
